import { render, staticRenderFns } from "./SizeRowOffShore.vue?vue&type=template&id=78785933"
import script from "./SizeRowOffShore.vue?vue&type=script&lang=js"
export * from "./SizeRowOffShore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports